"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _vuex = require("vuex");

var _rule = require("@/utils/rule");

var _user = require("@/api/user");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      dialogBind: false,
      dialogNickname: false,
      dialogData: {},
      userInfoRule: _rule.userInfoRule,
      sendCodeLoading: false,
      codeBtnText: '发送验证码',
      sendCodeTimer: null,
      sendCodeDefaultSecond: 60,
      sendCodeSecond: 60
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['userInfo', 'isVip', 'vipLevel'])),
  created: function created() {
    console.log(this.userInfo);
    this.$store.dispatch('user/getInfo', {
      refreshUserInfo: true,
      refreshVip: true
    });
  },
  methods: {
    showBindEmail: function showBindEmail() {
      var _this = this;

      this.dialogData = {};
      this.$nextTick(function () {
        _this.$refs['bindForm'].clearValidate();
      });
      this.dialogBind = true;
    },
    hiddenBindEmail: function hiddenBindEmail() {
      this.dialogBind = false;
      this.sendCodeLoading = false;
    },
    bindEmail: function bindEmail() {
      var _this2 = this;

      this.$refs['bindForm'].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // debugger
                  if (valid) {
                    (0, _user.verifyMail)({
                      email: _this2.dialogData.email,
                      code: _this2.dialogData.code
                    }).then( /*#__PURE__*/function () {
                      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                        return regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('user/getInfo', {
                                  refreshUserInfo: true,
                                  refreshVip: true
                                });

                              case 2:
                                _this2.hiddenBindEmail();

                                _this2.$message.success('绑定成功');

                              case 4:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      }));

                      return function (_x2) {
                        return _ref2.apply(this, arguments);
                      };
                    }());
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    sendCode: function sendCode() {
      var _this3 = this;

      if (this.sendCodeLoading) return;
      this.$refs['bindForm'].validateField('email', function (err) {
        // console.log(arguments)
        // debugger
        if (!err) {
          _this3.sendCodeLoading = true;
          (0, _user.sendEmailCode)({
            email: _this3.dialogData.email
          }).then(function (_) {
            _this3.sendCodeSecond = _this3.sendCodeDefaultSecond;
            _this3.sendCodeTimer = setInterval(function () {
              _this3.codeBtnText = _this3.sendCodeSecond + 's后重新发送';
              _this3.sendCodeSecond--;

              if (_this3.sendCodeSecond <= 0) {
                _this3.sendCodeLoading = false;
                _this3.codeBtnText = '发送验证码';
                clearInterval(_this3.sendCodeTimer);
              }
            }, 1000);
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        name: 'Home'
      });
    }
  }
};
exports.default = _default;